export default __webpack_public_path__ + "static/media/baee9a0110f35f70d67832704e32b260.svg";